import { api } from './client'

export interface OtpStartResult {
  requestId: string
  expiresAt: string
}

export interface OtpVerifyResult {
  token: string
  userId: string
}

export async function otpStart(phone: string): Promise<OtpStartResult> {
  return api<OtpStartResult>('/auth/otp/start', {
    method: 'POST',
    body: JSON.stringify({ phone }),
  })
}

export async function otpVerify(requestId: string, code: string): Promise<OtpVerifyResult> {
  return api<OtpVerifyResult>('/auth/otp/verify', {
    method: 'POST',
    body: JSON.stringify({ requestId, code }),
  })
}

const TOKEN_KEY = 'avt:jwt'
const USER_KEY = 'avt:userId'

export const authStore = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  getUserId: () => localStorage.getItem(USER_KEY),
  set: (token: string, userId: string) => {
    localStorage.setItem(TOKEN_KEY, token)
    localStorage.setItem(USER_KEY, userId)
  },
  clear: () => {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
  },
}
